var lastArrayEach = require('./lastArrayEach')
var keys = require('./keys')

function lastObjectEach (obj, iterate, context) {
  lastArrayEach(keys(obj), function (key) {
    iterate.call(context, obj[key], key, obj)
  })
}

module.exports = lastObjectEach



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/lastObjectEach.js
// module id = 454
// module chunks = 75